import { api } from "../../api"

export async function loadNavigation(): Promise<Navigation[]> {
    let nav = await api<Navigation[]>("navigation", {})
    return nav.data
}
